import { BaseStore } from "stores/base_store"
import { runInAction, makeAutoObservable } from "mobx"
import { api_get } from "api/utils"
import { CursorType } from "utils/types"
export type CallIncomingType = {
    key: string;
    uuid: string;
    identity: string;
    associated_type: string;
    associated_uuid: string;
    incoming_phone_number: string;
    number_to: string;
    number_from: string;
    twilio_duration: string;
    file_association: string;

    date_created: string;
    date_updated: string;
    updateProps?: (attributes: CallIncomingType) => void;
};

// Domain object CallIncoming
export class CallIncoming implements CallIncomingType {
    key = "";
    uuid = "";
    identity = "";

    associated_type = "";
    associated_uuid = "";
    incoming_phone_number = "";
    number_to = "";
    number_from = "";
    twilio_duration = "";
    file_association = "";

    date_created = "";
    date_updated = "";

    constructor(attributes: CallIncomingType) {
        makeAutoObservable(this, {
            updateProps: false
        })
        if (attributes) {
            this.updateProps(attributes);
        }
    }

    updateProps(attributes: CallIncomingType) {
        runInAction(() => {
            Object.assign(this, attributes);
        });
    }
}


export class CallIncomingStore extends BaseStore<CallIncomingType, CallIncoming> {


    async fetchCallIncoming(uuid: string) {
        // Autogenerated
        const response = await api_get(`/call-incoming?uuid=${uuid}`);
        if(response.ok) {
            const data = await response.json();
            this.receiveUpdate(data);
            return data;
        }
        return null;
    }


    async fetchListByIdentityCallIncoming(identity_uuid: string, cursor?: CursorType): Promise<CallIncomingType[]>  {
        // Autogenerated
        var url = `/call-incoming/by-identity?identity=${identity_uuid}` +
            (cursor ? `&cursor=${cursor}` : '');
        const response = await api_get(url);
        if (response.ok) {
            const data = await response.json();
            this.receiveUpdate(data.items);
            if(data?.cursor) {
                this.fetchListByIdentityCallIncoming(identity_uuid, data.cursor);
            }
            // This returns as possibly incomplete list due to the cursor,
            // but CallIncomingStore.items is complete when .then() is called
            // so you can/should just use that.
            return data.items;
        }
        return [];
    };


    async fetchListByAssociationCallIncoming(identity: string, associated_type: string, associated_uuid: string, cursor?: CursorType): Promise<CallIncomingType[]>  {
        // Autogenerated
        const url = "/call-incoming/list-by-association";
        const params = {
            identity,
            associated_type,
            associated_uuid,
            cursor: cursor || ''
        };
        const response = await api_get(url, params);
        if (response.ok) {
            const data = await response.json();
            this.receiveUpdate(data.items);
            if(data?.cursor) {
                this.fetchListByAssociationCallIncoming(identity, associated_type, associated_type, data.cursor);
            }
            // This returns as possibly incomplete list due to the cursor,
            // but CallIncomingStore.items is complete when .then() is called
            // so you can/should just use that.
            return data.items;
        }
        return [];
    };

    async fetchListByIncomingPhoneNumber(identity: string, incoming_phone_number: string, cursor?: CursorType) {
        const url = "/call-incoming/list-by-incoming-phone-number";
        const params = {
            identity,
            incoming_phone_number,
            cursor: cursor || ''
        };
        const response = await api_get(url, params);
        if (response.ok) {
            const data = await response.json();
            console.log("fetchListByIncomingPhoneNumber data: %o", data);
            this.receiveUpdate(data.items);
            if(data?.cursor) {
                this.fetchListByIncomingPhoneNumber(identity, incoming_phone_number, data.cursor);
            }
            // This returns as possibly incomplete list due to the cursor,
            // but CallIncomingStore.items is complete when .then() is called
            // so you can/should just use that.
            return data.items;
        }
        return [];
    }


    modelConstructor() {
        return CallIncoming;
    }

}
